export const breadcrumbList = [
  {
    name: '营销管理',
    path: ''
  },
  {
    name: '邀请有礼列表',
    path: '/main/invite/list'
  },
  {
    name: '新增活动',
    path: ''
  }
]

export const addServeRules = {
  serveName: [{ required: true, message: '请输入服务名称', trigger: 'blur' }],
  serveKind: [{ required: true, message: '请选择服务分类', trigger: 'change' }],
  serveTags: [{ required: true, message: '请选择标签', trigger: 'change' }],
  // servePayFlag: [{ required: true, message: '请选择线上预约', trigger: 'change' }],
  serveLength: [{ required: true, message: '请输入服务时长', trigger: 'blur' }],
  prepare: [{ required: true, message: '请输入筹备时长', trigger: 'blur' }],
  price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
  displayApplet:[{ required: true, message: '请选择是否小程序/网店展示', trigger: 'change' }]
}
